import React, { createContext, FC, PropsWithChildren, useContext } from "react";
import { EditContextState } from "./types";

const INITIAL_STATE: EditContextState = {
  editMode: false,
  draft: null,
  merch: [],
  events: [],
  editHandlers: {
    onFeature: () => null,
    onHide: () => null,
    onSectionsReorder: () => null,
    onItemsReorder: () => null,
    onBioBlur: () => null,
    onAvatarChange: () => null,
  },
};

const editContext = createContext<EditContextState>(INITIAL_STATE);

export const EditContextProvider: FC<PropsWithChildren<EditContextState>> = ({
  children,
  ...ctx
}) => {
  return <editContext.Provider value={ctx}>{children}</editContext.Provider>;
};

export const useEditMode = () => {
  const editMode = useContext(editContext);
  return editMode;
};
